import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { LocalProvider } from "./Context/LocalProvider";
import { Provider } from "react-redux";
import store from "./utils/appStore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LocalProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </LocalProvider>
    </BrowserRouter>
  </React.StrictMode>
);
